import { apiInstance, apiResponse, getLoadingState, ApiError } from '../../Api';
import { MonografiaModel } from '../Monografia';

export const getAgendamentoBanca = async (monografiaId: number): Promise<apiResponse<MonografiaModel | undefined>> => {
  try {
    const fetchResult = await apiInstance
      .get<MonografiaModel>(`/funcionario/agendamento/${monografiaId}`);

    return {
      data: fetchResult.data,
      status: getLoadingState(fetchResult.status)
    } as apiResponse<MonografiaModel>;
  } catch (error) {
    const status = error.response ? error.response.status : 500;
    return {
      data: undefined,
      status: getLoadingState(status)
    };
  }
};

export const getLocais = async (): Promise<apiResponse<{ id: number, nome: string }[]>> => {
  try {
    const fetchResult = await apiInstance.get<{ id: number, nome: string }[]>('funcionario/agendamento/locais');
    return {
      data: fetchResult.data,
      status: getLoadingState(fetchResult.status)
    };
  } catch (error) {
    const status = error.response ? error.response.status : 500;
    return {
      data: [],
      status: getLoadingState(status)
    };
  }
};

export const confirmarAgendamentoBanca = async (
  monografiaId: number, localId: number, local: string, dia: string, hora: string, linkEvento: string): Promise<apiResponse<ApiError[]>> => {
  
  try {
    const dataHoraAgendamento = new Date(dia + ' ' + hora +':00.000Z');
    const agendamentoResult = await apiInstance.post('funcionario/agendamento',
      { MonografiaId: monografiaId, DataInicio: dataHoraAgendamento, ResourceId: localId, Local: local, LinkEvento: linkEvento });
    return {
      data: [],
      status: getLoadingState(agendamentoResult.status)
    };
  } catch (error) {
    const status = error.response ? error.response.status : 500;
    return {
      data: error.response ? error.response.data : [],
      status: getLoadingState(status)
    };
  }
};

export const alterarLinkDoEvento = async (
  monografiaId: number, linkEvento: string): Promise<apiResponse<ApiError[]>> => {

  try {
    const agendamentoResult = await apiInstance.put('funcionario/agendamento/atualizarlink',
      { MonografiaId: monografiaId, LinkEvento: linkEvento });

    return {
      data: [],
      status: getLoadingState(agendamentoResult.status)
    };
  } catch (error) {
    const status = error.response ? error.response.status : 500;
    return {
      data: error.response ? error.response.data : [],
      status: getLoadingState(status)
    };
  }
};
		

export const cancelaAgendamentoBanca = async (monografiaId: number, justificativa: string): Promise<apiResponse<ApiError[]>> => {
  try {
    const agendamentoResult = await apiInstance.post('funcionario/agendamento/remove',
      { MonografiaId: monografiaId, Justificativa: justificativa });

    return {
      data: [],
      status: getLoadingState(agendamentoResult.status)
    };
  } catch (error) {
    const status = error.response ? error.response.status : 500;
    return {
      data: error.response ? error.response.data : [],
      status: getLoadingState(status)
    };
  }
};